import React, { useEffect, useState, useCallback, useRef } from 'react';
import axios from 'axios';
import Navbar from '../components/Navbar';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import * as XLSX from 'xlsx';
import LOGO_BACON_B64 from '../utils/logoBacon';

const API = 'https://bacmt.com.ar';
/*const API = 'http://192.168.2.25:3000';*/


const EVENTOS_OCULTOS = [9, 12];

const EVENTOS_MARCACION = [14, 15, 16, 17];
const EVENTOS_PUREZA = [18];
const EVENTOS_MOLI = [19];

const PROCESOS_POR_PAGINA = 15;

const contar = (regs, codigos) =>
    regs.filter(r => codigos.includes(Number(r.codigo_evento))).length;

const catContador = (cod) => {
    cod = Number(cod);
    if (EVENTOS_MARCACION.includes(cod)) return { key: 'CM', label: 'Marcación' };
    if (EVENTOS_PUREZA.includes(cod)) return { key: 'CP', label: 'Pureza' };
    if (EVENTOS_MOLI.includes(cod)) return { key: 'CMo', label: 'Molibdeno' };
    return null;
};

const infoEvento = (cod) => {
    cod = Number(cod);
    if ([14, 15, 16, 17].includes(cod)) return { cat: 'CM', rol: 'inicio' };
    if (cod === 2) return { cat: 'CM', rol: 'fin' };
    if (cod === 18) return { cat: 'CP', rol: 'inicio' };
    if ([3, 4, 5, 6].includes(cod)) return { cat: 'CP', rol: 'fin' };
    if (cod === 19) return { cat: 'CMo', rol: 'inicio' };
    if ([7, 8].includes(cod)) return { cat: 'CMo', rol: 'fin' };
    if (cod === 13) return { cat: null, rol: 'cancela' };
    return { cat: null, rol: 'suelto' };
};

const COLOR_CAT = { CM: 'var(--accent)', CP: 'var(--accent-cyan)', CMo: '#f5c518' };

const COLOR_EVENTO = {
    negro: 'var(--text-primary)',
    verde: 'var(--success)',
    rojo: 'var(--danger)',
    amarillo: '#f5c518',
};

const hhmm = (fechaStr) => {
    if (!fechaStr) return '';
    const d = new Date(fechaStr);
    return d.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
};

const labelEvento = (r) => {
    const cod = Number(r.codigo_evento);
    const tempSet = r.temp_set;
    const timeSet = r.time_set;
    const C = COLOR_EVENTO;
    switch (cod) {
        case 1: return { texto: 'Equipo encendido.', color: C.negro };
        case 2: return {
            texto: `Fin de la marcación. (Temperatura: ${tempSet}°C - Tiempo: ${timeSet}min)`,
            color: C.verde,
        };
        case 3: return { texto: 'Fin del test de pureza. Baja actividad de la muestra.', color: C.rojo };
        case 4: return { texto: 'Fin del test de pureza. Saturación de los detectores.', color: C.rojo };
        case 5: return { texto: 'Fin del test de pureza. Pureza mayor al 90%.', color: C.verde };
        case 6: return { texto: 'Fin del test de pureza. Pureza menor al 90%.', color: C.rojo };
        case 7: return { texto: 'Fin del test de Molibdeno. Bajo conteo de Molibdeno en la muestra.', color: C.verde };
        case 8: return { texto: 'Fin del test de Molibdeno. Mucho conteo de Molibdeno en la muestra.', color: C.rojo };
        case 9: return null;
        case 10: return { texto: 'Error grave en el calefactor.', color: C.rojo };
        case 11: {
            const reps = Number(r.repeticiones) || 1;
            if (reps > 1) {
                const ult = hhmm(r.ultima_repeticion || r.fecha);
                return { texto: `Se detectó alto fondo (${reps} veces). Última vez ${ult}`, color: C.amarillo };
            }
            return { texto: 'Se detectó alto fondo.', color: C.amarillo };
        }
        case 12: return null;
        case 13: return { texto: 'Proceso cancelado.', color: C.rojo };
        case 14: return { texto: 'Se inicia un proceso de marcación de Sestamibi.', color: C.negro };
        case 15: return { texto: 'Se inicia un proceso de marcación de Neurobac.', color: C.negro };
        case 16: return { texto: 'Se inicia un proceso de marcación de Osteobac.', color: C.negro };
        case 17: return { texto: 'Se inicia un proceso de marcación de un programa personalizado.', color: C.negro };
        case 18: return { texto: 'Se inicia un test de pureza.', color: C.negro };
        case 19: return { texto: 'Se inicia un test de Molibdeno.', color: C.negro };
        default: return { texto: `Evento desconocido (${cod}).`, color: C.negro };
    }
};

const finMarcacion = (r) => {
    if (Number(r.codigo_evento) !== 2) return '—';
    if (r.temp_set != null && r.time_set != null) return `${r.temp_set}° @ ${r.time_set}min`;
    return '—';
};

const agruparProcesos = (registrosNewestFirst) => {
    const cronologico = [...registrosNewestFirst].reverse();
    const grupos = [];
    const abiertos = {};

    cronologico.forEach(r => {
        const info = infoEvento(r.codigo_evento);

        if (info.rol === 'inicio') {
            const g = { tipo: 'proceso', cat: info.cat, rows: [r] };
            grupos.push(g);
            abiertos[info.cat] = g;

        } else if (info.rol === 'fin') {
            const g = abiertos[info.cat];
            if (g) { g.rows.push(r); delete abiertos[info.cat]; }
            else { grupos.push({ tipo: 'proceso', cat: info.cat, rows: [r] }); }

        } else if (info.rol === 'cancela') {
            const claves = Object.keys(abiertos);
            if (claves.length) {
                let ultimaClave = null, ultimoIdx = -1;
                claves.forEach(k => {
                    const idx = grupos.indexOf(abiertos[k]);
                    if (idx > ultimoIdx) { ultimoIdx = idx; ultimaClave = k; }
                });
                abiertos[ultimaClave].rows.push(r);
                delete abiertos[ultimaClave];
            } else {
                grupos.push({ tipo: 'suelto', rows: [r] });
            }

        } else {
            grupos.push({ tipo: 'suelto', rows: [r] });
        }
    });

    return [...grupos].reverse().map(g => ({ ...g, rows: [...g.rows].reverse() }));
};

const exportarExcel = (registros, equipo) => {
    const datos = registros.map(r => {
        const ev = labelEvento(r);
        return {
            'Evento': ev ? ev.texto : '—',
            'Fin de marcación': finMarcacion(r),
            'Fecha/Hora': new Date(r.fecha).toLocaleString(),
        };
    });
    const ws = XLSX.utils.json_to_sheet(datos);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Registros');
    XLSX.writeFile(wb, `bacmt_${equipo}_${new Date().toISOString().slice(0, 10)}.xlsx`);
};

const NAVY = [16, 36, 71];

// Header branded para los PDF del Dashboard (con logo)
const headerPDFDash = (doc, titulo, subtitulo) => {
    const w = doc.internal.pageSize.getWidth();
    doc.setFillColor(...NAVY);
    doc.rect(0, 0, w, 30, 'F');
    try { doc.addImage(LOGO_BACON_B64, 'JPEG', 6, 3, 24, 24); } catch (e) { /* sigue sin logo si falla */ }
    doc.setTextColor(255, 255, 255);
    doc.setFontSize(16); doc.setFont(undefined, 'bold');
    doc.text('BAC MT 2.0', 36, 13);
    doc.setFontSize(10); doc.setFont(undefined, 'normal');
    doc.text(titulo, 36, 21);
    doc.setFontSize(9); doc.setFont(undefined, 'bold');
    doc.text('Laboratorios Bacon', w - 14, 12, { align: 'right' });
    doc.setFontSize(7.5); doc.setFont(undefined, 'normal');
    doc.setTextColor(200, 210, 230);
    doc.text(`Generado: ${new Date().toLocaleString()}`, w - 14, 19, { align: 'right' });
    doc.setTextColor(90, 90, 90); doc.setFontSize(8.5);
    doc.text(subtitulo, 14, 38);
    return 44;
};

const exportarPDF = (registros, equipo) => {
    const doc = new jsPDF({ orientation: 'landscape' });
    const y = headerPDFDash(doc, 'Registros del Dashboard', `Equipo: ${equipo}`);
    autoTable(doc, {
        startY: y,
        head: [['Evento', 'Datos', 'Fecha']],
        body: registros.map(r => {
            const ev = labelEvento(r);
            return [
                ev ? ev.texto : '—',
                finMarcacion(r),
                new Date(r.fecha).toLocaleString(),
            ];
        }),
        styles: { fontSize: 8 },
        headStyles: { fillColor: NAVY },
    });
    doc.save(`bacmt_${equipo}_${new Date().toISOString().slice(0, 10)}.pdf`);
};

const exportarEventoPDF = (r) => {
    const ev = labelEvento(r);
    const doc = new jsPDF();
    const y = headerPDFDash(doc, 'Detalle de evento', `Evento #${r.id}`);
    autoTable(doc, {
        startY: y,
        head: [['Campo', 'Valor']],
        body: [
            ['Evento', ev ? ev.texto : `Código ${r.codigo_evento}`],
            ['Datos de marcación', finMarcacion(r)],
            ['Fecha/Hora', new Date(r.fecha).toLocaleString()],
        ],
        styles: { fontSize: 10 },
        headStyles: { fillColor: NAVY },
        columnStyles: { 0: { fontStyle: 'bold', cellWidth: 50 } },
    });
    doc.save(`bacmt_evento_${r.id}.pdf`);
};

function Combobox({ label, valorTexto, placeholder, opciones, onSelect }) {
    const [abierto, setAbierto] = useState(false);
    const [busqueda, setBusqueda] = useState('');
    const ref = useRef(null);

    useEffect(() => {
        const onClick = (e) => { if (ref.current && !ref.current.contains(e.target)) setAbierto(false); };
        const onEsc = (e) => { if (e.key === 'Escape') setAbierto(false); };
        document.addEventListener('mousedown', onClick);
        document.addEventListener('keydown', onEsc);
        return () => {
            document.removeEventListener('mousedown', onClick);
            document.removeEventListener('keydown', onEsc);
        };
    }, []);

    const filtradas = opciones.filter(o => {
        const txt = `${o.principal || ''} ${o.secundario || ''}`.toLowerCase();
        return txt.includes(busqueda.trim().toLowerCase());
    });

    const elegir = (value) => {
        onSelect(value);
        setAbierto(false);
        setBusqueda('');
    };

    return (
        <div style={styles.cbWrap} ref={ref}>
            <label style={styles.selectorLabel}>{label}</label>
            <button
                style={{ ...styles.cbTrigger, ...(abierto ? styles.cbTriggerActivo : {}) }}
                onClick={() => setAbierto(v => !v)}
            >
                <span style={styles.cbTriggerTxt}>{valorTexto}</span>
                <span style={{ ...styles.cbChevron, transform: abierto ? 'rotate(180deg)' : 'rotate(0deg)' }}>▾</span>
            </button>

            {abierto && (
                <div style={styles.cbPanel}>
                    <input
                        autoFocus
                        type="text"
                        placeholder={placeholder}
                        value={busqueda}
                        onChange={(e) => setBusqueda(e.target.value)}
                        style={styles.cbInput}
                    />
                    <div style={styles.cbLista}>
                        {filtradas.length === 0 ? (
                            <div style={styles.cbVacio}>Sin coincidencias para "{busqueda}"</div>
                        ) : (
                            filtradas.map(o => (
                                <button key={o.value} style={styles.cbItem} onClick={() => elegir(o.value)}>
                                    <span style={styles.cbItemPrincipal}>{o.principal}</span>
                                    {o.secundario && <span style={styles.cbItemSecundario}>{o.secundario}</span>}
                                </button>
                            ))
                        )}
                    </div>
                </div>
            )}
        </div>
    );
}

const rangoPeriodo = (modo, offset) => {
    const ahora = new Date();
    let inicio, fin;

    if (modo === 'hoy') {
        // Día actual (offset en días: 0 hoy, -1 ayer, etc.)
        inicio = new Date(ahora);
        inicio.setHours(0, 0, 0, 0);
        inicio.setDate(inicio.getDate() + offset);
        fin = new Date(inicio);
        fin.setDate(fin.getDate() + 1);
    } else if (modo === 'semana') {
        const base = new Date(ahora);
        const day = (base.getDay() + 6) % 7;
        base.setHours(0, 0, 0, 0);
        base.setDate(base.getDate() - day + offset * 7);
        inicio = new Date(base);
        fin = new Date(base);
        fin.setDate(fin.getDate() + 7);
    } else if (modo === 'mes') {
        inicio = new Date(ahora.getFullYear(), ahora.getMonth() + offset, 1, 0, 0, 0, 0);
        fin = new Date(ahora.getFullYear(), ahora.getMonth() + offset + 1, 1, 0, 0, 0, 0);
    } else if (modo === 'anio') {
        inicio = new Date(ahora.getFullYear() + offset, 0, 1, 0, 0, 0, 0);
        fin = new Date(ahora.getFullYear() + offset + 1, 0, 1, 0, 0, 0, 0);
    } else {
        return null;
    }
    return { inicio, fin };
};

const etiquetaPeriodo = (modo, offset) => {
    const r = rangoPeriodo(modo, offset);
    if (!r) return 'Todo el historial';
    const { inicio } = r;
    if (modo === 'hoy') {
        const hoy = new Date(); hoy.setHours(0,0,0,0);
        if (inicio.getTime() === hoy.getTime()) return 'Hoy';
        const ayer = new Date(hoy); ayer.setDate(ayer.getDate() - 1);
        if (inicio.getTime() === ayer.getTime()) return 'Ayer';
        return inicio.toLocaleDateString('es-AR', { weekday: 'long', day: '2-digit', month: '2-digit' });
    }
    if (modo === 'semana') {
        const finSem = new Date(r.fin); finSem.setDate(finSem.getDate() - 1);
        const f = (d) => d.toLocaleDateString('es-AR', { day: '2-digit', month: '2-digit' });
        return `Semana ${f(inicio)} – ${f(finSem)}`;
    }
    if (modo === 'mes') {
        return inicio.toLocaleDateString('es-AR', { month: 'long', year: 'numeric' });
    }
    if (modo === 'anio') {
        return `Año ${inicio.getFullYear()}`;
    }
    return '';
};

const GRID_COLS = 'minmax(220px,1fr) 150px 150px 170px 90px';

function Dashboard() {
    const [registros, setRegistros] = useState([]);
    const [equipos, setEquipos] = useState([]);
    const [empresaSeleccionada, setEmpresaSeleccionada] = useState('todas');
    const [equipoSeleccionado, setEquipoSeleccionado] = useState('todos');
    const [error, setError] = useState('');
    const [ultimaAct, setUltimaAct] = useState(null);
    const inicializado = useRef(false);

    const [modoPeriodo, setModoPeriodo] = useState('todo');
    const [offsetPeriodo, setOffsetPeriodo] = useState(0);
    const [pagina, setPagina] = useState(1);

    // Vista cruda: muestra los registros tal cual la base, sin agrupar ni procesar.
    const [vistaCruda, setVistaCruda] = useState(false);

    // --- Registrar equipo (solo superadmin) ---
    const usuarioActual = (() => {
        try { return JSON.parse(localStorage.getItem('usuario')); }
        catch { return null; }
    })();
    const esSuperadmin = usuarioActual?.rol === 'superadmin';

    const [modalAbierto, setModalAbierto] = useState(false);
    const [formEquipo, setFormEquipo] = useState({ serie: '', num_interno: '', descripcion: '' });
    const [guardando, setGuardando] = useState(false);
    const [msgEquipo, setMsgEquipo] = useState({ tipo: '', texto: '' });

    const abrirModal = () => {
        setFormEquipo({ serie: '', num_interno: '', descripcion: '' });
        setMsgEquipo({ tipo: '', texto: '' });
        setModalAbierto(true);
    };

    const guardarEquipo = async () => {
        const serie = formEquipo.serie.trim();
        const num = formEquipo.num_interno.trim();
        if (!serie || !num) {
            setMsgEquipo({ tipo: 'error', texto: 'La serie y el número interno son obligatorios.' });
            return;
        }
        setGuardando(true);
        setMsgEquipo({ tipo: '', texto: '' });
        const token = localStorage.getItem('token');
        try {
            await axios.post(`${API}/api/equipos`,
                { serie, num_interno: num, descripcion: formEquipo.descripcion.trim() || null, id_empresa: null },
                { headers: { Authorization: `Bearer ${token}` } }
            );
            setMsgEquipo({ tipo: 'ok', texto: '✓ Equipo registrado correctamente.' });
            setFormEquipo({ serie: '', num_interno: '', descripcion: '' });
            traerEquipos(); // refresca la lista
        } catch (err) {
            const txt = err.response?.data?.error || 'No se pudo registrar el equipo.';
            setMsgEquipo({ tipo: 'error', texto: '⚠ ' + txt });
        } finally {
            setGuardando(false);
        }
    };

    const traerEquipos = useCallback(async () => {
        const token = localStorage.getItem('token');
        try {
            const res = await axios.get(`${API}/api/mis-equipos`, {
                headers: { Authorization: `Bearer ${token}` }
            });
            setEquipos(res.data);
        } catch (err) { console.error('Error cargando equipos', err); }
    }, []);

    const traerDatos = useCallback(async () => {
        const token = localStorage.getItem('token');
        try {
            const res = await axios.get(`${API}/api/datos-medicos`, {
                headers: { Authorization: `Bearer ${token}` }
            });
            setRegistros(res.data);
            setUltimaAct(new Date());
            setError('');
        } catch (err) { setError('Error al cargar los datos. Verificá tu sesión.'); }
    }, []);

    useEffect(() => { traerEquipos(); }, [traerEquipos]);
    useEffect(() => {
        traerDatos();
        const interval = setInterval(traerDatos, 5000);
        return () => clearInterval(interval);
    }, [traerDatos]);

    const empresas = [...new Map(
        equipos
            .filter(e => e.empresa_nombre || e.empresa)
            .map(e => [String(e.empresa_id ?? e.empresa_nombre ?? e.empresa), e.empresa_nombre || e.empresa])
    ).entries()];

    useEffect(() => {
        if (inicializado.current || equipos.length === 0) return;
        inicializado.current = true;

        const primeraEmp = empresas[0]?.[0] ?? null;
        if (primeraEmp) setEmpresaSeleccionada(primeraEmp);

        const eqDeEmp = primeraEmp
            ? equipos.filter(e => String(e.empresa_id ?? e.empresa_nombre ?? e.empresa) === primeraEmp)
            : equipos;
        const primerEq = eqDeEmp[0]?.num_interno ?? null;
        if (primerEq) setEquipoSeleccionado(primerEq);
    }, [equipos]); // eslint-disable-line react-hooks/exhaustive-deps

    const equiposFiltrados = empresaSeleccionada === 'todas'
        ? equipos
        : equipos.filter(e => String(e.empresa_id ?? e.empresa_nombre ?? e.empresa) === empresaSeleccionada);

    let regs = registros;
    if (empresaSeleccionada !== 'todas') {
        const setNumInternos = new Set(equiposFiltrados.map(e => e.num_interno));
        regs = regs.filter(r => setNumInternos.has(r.dispositivo_id));
    }
    if (equipoSeleccionado !== 'todos') {
        regs = regs.filter(r => r.dispositivo_id === equipoSeleccionado);
    }

    const rango = rangoPeriodo(modoPeriodo, offsetPeriodo);
    if (rango) {
        regs = regs.filter(r => {
            const f = new Date(r.fecha);
            return f >= rango.inicio && f < rango.fin;
        });
    }

    const registrosVisibles = regs.filter(r => !EVENTOS_OCULTOS.includes(Number(r.codigo_evento)));

    const cantMarcaciones = contar(registrosVisibles, EVENTOS_MARCACION);
    const cantPureza = contar(registrosVisibles, EVENTOS_PUREZA);
    const cantMoli = contar(registrosVisibles, EVENTOS_MOLI);

    const orden = {};
    const acum = { CM: 0, CP: 0, CMo: 0 };
    [...registrosVisibles].reverse().forEach(r => {
        const c = catContador(r.codigo_evento);
        if (c) { acum[c.key] += 1; orden[r.id] = { ...c, n: acum[c.key] }; }
    });

    const grupos = agruparProcesos(registrosVisibles);

    const totalPaginas = Math.max(1, Math.ceil(grupos.length / PROCESOS_POR_PAGINA));
    const paginaSegura = Math.min(pagina, totalPaginas);
    const desde = (paginaSegura - 1) * PROCESOS_POR_PAGINA;
    const gruposPagina = grupos.slice(desde, desde + PROCESOS_POR_PAGINA);

    useEffect(() => { setPagina(1); }, [empresaSeleccionada, equipoSeleccionado, modoPeriodo, offsetPeriodo]);

    const seleccionarEmpresa = (id) => {
        setEmpresaSeleccionada(id);
        setEquipoSeleccionado('todos');
    };

    const cambiarModoPeriodo = (modo) => {
        setModoPeriodo(modo);
        setOffsetPeriodo(0);
    };

    const opcionesEmpresa = [
        { value: 'todas', principal: 'Todas las empresas' },
        ...empresas.map(([id, nombre]) => ({ value: id, principal: nombre })),
    ];
    const textoEmpresa = empresaSeleccionada === 'todas'
        ? 'Todas las empresas'
        : (empresas.find(([id]) => id === empresaSeleccionada)?.[1] || empresaSeleccionada);

    const opcionesEquipo = [
        { value: 'todos', principal: 'Todos los equipos' },
        ...equiposFiltrados.map(eq => ({
            value: eq.num_interno,
            principal: eq.serie || eq.descripcion || eq.num_interno,
            secundario: eq.num_interno,
        })),
    ];
    const textoEquipo = equipoSeleccionado === 'todos'
        ? 'Todos los equipos'
        : (() => {
            const eq = equiposFiltrados.find(e => e.num_interno === equipoSeleccionado);
            return eq ? (eq.serie || eq.descripcion || eq.num_interno) : equipoSeleccionado;
        })();

    const filaEvento = (r, conBordeArriba) => {
        const ev = labelEvento(r);
        const o = orden[r.id];
        return (
            <div key={r.id} style={{ ...styles.gridRow, ...(conBordeArriba ? styles.gridRowBorder : {}) }}>
                <span style={{ color: ev ? ev.color : 'var(--text-primary)', fontWeight: '500' }}>
                    {ev ? ev.texto : '—'}
                </span>
                <span>
                    {o ? (
                        <span style={styles.contadorBadge}>
                            {o.key} +1 <span style={styles.contadorNum}>#{o.n}</span>
                        </span>
                    ) : (
                        <span style={styles.tdDim}>—</span>
                    )}
                </span>
                <span style={{ ...styles.tdMono, color: 'var(--accent-cyan)', fontWeight: '600' }}>
                    {finMarcacion(r)}
                </span>
                <span style={styles.tdMono}>{new Date(r.fecha).toLocaleString()}</span>
                <span>
                    <button style={styles.btnPDFfila} onClick={() => exportarEventoPDF(r)} title="Descargar este evento en PDF">
                        ↓ PDF
                    </button>
                </span>
            </div>
        );
    };

    // Fila combinada para procesos (inicio+fin en un solo renglón)
    const filaProceso = (g) => {
        const rows = g.rows; // newest first
        // Identificar inicio y fin
        const inicioRow = rows.find(r => [14,15,16,17,18,19].includes(Number(r.codigo_evento)));
        const finRow = rows.find(r => [2,3,4,5,6,7,8].includes(Number(r.codigo_evento)));
        const cancelRow = rows.find(r => Number(r.codigo_evento) === 13);
        const ref = inicioRow || finRow || rows[0]; // referencia para key/id

        // Nombre del proceso
        const nombreProceso = (() => {
            if (!inicioRow) return 'Proceso';
            const c = Number(inicioRow.codigo_evento);
            if (c === 14) return 'Marcación Sestamibi';
            if (c === 15) return 'Marcación Neurobac';
            if (c === 16) return 'Marcación Osteobac';
            if (c === 17) return 'Marcación personalizada';
            if (c === 18) return 'Test de pureza';
            if (c === 19) return 'Test de Molibdeno';
            return 'Proceso';
        })();

        // Resultado
        let resultado = '';
        let colorResultado = 'var(--text-muted)';
        if (cancelRow) {
            resultado = 'Cancelado';
            colorResultado = 'var(--danger)';
        } else if (finRow) {
            const fc = Number(finRow.codigo_evento);
            if (fc === 2) { resultado = 'OK'; colorResultado = 'var(--success)'; }
            else if (fc === 5) { resultado = 'Pureza > 90%'; colorResultado = 'var(--success)'; }
            else if (fc === 6) { resultado = 'Pureza < 90%'; colorResultado = 'var(--danger)'; }
            else if (fc === 3) { resultado = 'Baja actividad'; colorResultado = 'var(--danger)'; }
            else if (fc === 4) { resultado = 'Saturación'; colorResultado = 'var(--danger)'; }
            else if (fc === 7) { resultado = 'Bajo conteo Mo'; colorResultado = 'var(--success)'; }
            else if (fc === 8) { resultado = 'Mucho conteo Mo'; colorResultado = 'var(--danger)'; }
        } else {
            resultado = 'En curso...';
            colorResultado = '#f5c518';
        }

        // Datos de marcación (temp/tiempo) del fin
        const datosMarc = finRow && Number(finRow.codigo_evento) === 2
            ? `${finRow.temp_set}°C / ${finRow.time_set}min`
            : '—';

        // Fechas
        const hh = (f) => new Date(f).toLocaleTimeString([], { hour:'2-digit', minute:'2-digit', second:'2-digit' });
        const fechaInicio = inicioRow ? hh(inicioRow.fecha) : '—';
        const fechaFin = finRow ? hh(finRow.fecha) : (cancelRow ? hh(cancelRow.fecha) : '');
        const fechaDisplay = fechaFin ? `${fechaInicio} → ${fechaFin}` : fechaInicio;
        const fechaDia = new Date((inicioRow || finRow || cancelRow || rows[0]).fecha).toLocaleDateString();

        // Contador (del evento de inicio)
        const o = inicioRow ? orden[inicioRow.id] : null;

        return (
            <div key={ref.id} style={styles.gridRow}>
                <span style={{ fontWeight: '500' }}>
                    <span style={{ color: 'var(--text-primary)' }}>{nombreProceso}</span>
                    <span style={{ color: colorResultado, marginLeft: '10px', fontSize: '0.82rem', fontWeight: '600' }}>
                        · {resultado}
                    </span>
                </span>
                <span>
                    {o ? (
                        <span style={styles.contadorBadge}>
                            {o.key} +1 <span style={styles.contadorNum}>#{o.n}</span>
                        </span>
                    ) : (
                        <span style={styles.tdDim}>—</span>
                    )}
                </span>
                <span style={{ ...styles.tdMono, color: 'var(--accent-cyan)', fontWeight: '600' }}>
                    {datosMarc}
                </span>
                <span style={styles.tdMono}>
                    <span>{fechaDia}</span>
                    <br/>
                    <span style={{ color: 'var(--text-muted)', fontSize: '0.75rem' }}>{fechaDisplay}</span>
                </span>
                <span>
                    <button style={styles.btnPDFfila} onClick={() => exportarEventoPDF(inicioRow || ref)} title="Descargar este proceso en PDF">
                        ↓ PDF
                    </button>
                </span>
            </div>
        );
    };

    const modos = [
        { key: 'todo', label: 'Todo' },
        { key: 'hoy', label: 'Hoy' },
        { key: 'semana', label: 'Semana' },
        { key: 'mes', label: 'Mes' },
        { key: 'anio', label: 'Año' },
    ];

    return (
        <div style={styles.page}>
            <Navbar />
            <div style={styles.contenido}>

                <div style={styles.header}>
                    <div>
                        <p style={styles.headerSub}>PANEL PRINCIPAL</p>
                        <h2 style={styles.headerTitulo}>Registros BAC MT</h2>
                    </div>
                    <div style={styles.headerDer}>
                        <div style={styles.liveBadge}><span style={styles.liveDot} /> EN VIVO</div>
                        {ultimaAct && <span style={styles.ultimaAct}>Act. {ultimaAct.toLocaleTimeString()}</span>}
                    </div>
                </div>

                {esSuperadmin && (
                    <div style={styles.adminBar}>
                        <span style={styles.adminBarLabel}>Panel de superadmin</span>
                        <button style={styles.btnRegistrar} onClick={abrirModal}>
                            <span style={styles.btnRegistrarPlus}>+</span> Registrar equipo
                        </button>
                    </div>
                )}

                {/* Fila superior: filtros a la izquierda, contadores a la derecha */}
                <div style={styles.topRow}>
                    <div style={styles.topLeft}>
                        {empresas.length > 0 && (
                            <Combobox
                                label="EMPRESA"
                                valorTexto={textoEmpresa}
                                placeholder="Buscar empresa..."
                                opciones={opcionesEmpresa}
                                onSelect={seleccionarEmpresa}
                            />
                        )}
                        {equiposFiltrados.length > 0 && (
                            <Combobox
                                label="EQUIPO"
                                valorTexto={textoEquipo}
                                placeholder="Buscar equipo por serie..."
                                opciones={opcionesEquipo}
                                onSelect={setEquipoSeleccionado}
                            />
                        )}

                        <div style={styles.periodoFila}>
                            <label style={styles.selectorLabel}>PERÍODO</label>
                            <div style={styles.periodoControles}>
                                <div style={styles.segmento}>
                                    {modos.map(m => (
                                        <button
                                            key={m.key}
                                            onClick={() => cambiarModoPeriodo(m.key)}
                                            style={{
                                                ...styles.segBtn,
                                                ...(modoPeriodo === m.key ? styles.segBtnActivo : {}),
                                            }}
                                        >
                                            {m.label}
                                        </button>
                                    ))}
                                </div>

                                {modoPeriodo !== 'todo' && (
                                    <div style={styles.navPeriodo}>
                                        <button style={styles.navBtn} onClick={() => setOffsetPeriodo(o => o - 1)} title="Período anterior">‹</button>
                                        <span style={styles.navPeriodoTxt}>{etiquetaPeriodo(modoPeriodo, offsetPeriodo)}</span>
                                        <button
                                            style={{ ...styles.navBtn, ...(offsetPeriodo >= 0 ? styles.navBtnDisabled : {}) }}
                                            onClick={() => setOffsetPeriodo(o => Math.min(0, o + 1))}
                                            disabled={offsetPeriodo >= 0}
                                            title="Período siguiente"
                                        >›</button>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>

                    {/* Contadores a la derecha */}
                    <div style={styles.card}>
                        <p style={styles.cardLabel}>CONTADORES</p>
                        <div style={styles.contBloque}>
                            <span style={styles.contBloqueTxt}>Cantidad marcaciones <span style={styles.contBloqueKey}>(CM)</span></span>
                            <span style={styles.contBloqueNum}>{cantMarcaciones}</span>
                        </div>
                        <div style={styles.contBloque}>
                            <span style={styles.contBloqueTxt}>Cantidad pureza <span style={styles.contBloqueKey}>(CP)</span></span>
                            <span style={styles.contBloqueNum}>{cantPureza}</span>
                        </div>
                        <div style={styles.contBloque}>
                            <span style={styles.contBloqueTxt}>Cantidad Molibdeno <span style={styles.contBloqueKey}>(CMo)</span></span>
                            <span style={styles.contBloqueNum}>{cantMoli}</span>
                        </div>
                    </div>
                </div>

                {error && <div style={styles.errorBox}>⚠ {error}</div>}

                <div style={styles.exportRow}>
                    <span style={styles.exportLabel}>
                        {registrosVisibles.length} registros · {grupos.length} procesos
                    </span>
                    <div style={styles.exportBtns}>
                        {esSuperadmin && (
                            <button
                                style={{ ...styles.btnVistaCruda, ...(vistaCruda ? styles.btnVistaCrudaActivo : {}) }}
                                onClick={() => setVistaCruda(v => !v)}
                                title="Alternar entre vista normal y datos crudos"
                            >
                                {vistaCruda ? '↩ Vista normal' : '⛁ Datos crudos'}
                            </button>
                        )}
                        <button style={styles.btnExcel} onClick={() => exportarExcel(registrosVisibles, equipoSeleccionado)} disabled={registrosVisibles.length === 0}>↓ Excel</button>
                        <button style={styles.btnPDF} onClick={() => exportarPDF(registrosVisibles, equipoSeleccionado)} disabled={registrosVisibles.length === 0}>↓ PDF</button>
                    </div>
                </div>

                {vistaCruda && esSuperadmin ? (
                    /* ===== VISTA CRUDA: registros tal cual la base ===== */
                    <div style={styles.crudaScrollWrap}>
                        <table style={styles.tablaCruda}>
                            <thead>
                                <tr>
                                    <th style={styles.thCruda}>ID</th>
                                    <th style={styles.thCruda}>Dispositivo (num_interno)</th>
                                    <th style={styles.thCruda}>Código evento</th>
                                    <th style={styles.thCruda}>Descripción</th>
                                    <th style={styles.thCruda}>Temp. seteada</th>
                                    <th style={styles.thCruda}>Tiempo seteado</th>
                                    <th style={styles.thCruda}>Temp. real</th>
                                    <th style={styles.thCruda}>Cuentas Fase Org. (FO)</th>
                                    <th style={styles.thCruda}>Cuentas Fase Ac. (FA)</th>
                                    <th style={styles.thCruda}>Valor pureza</th>
                                    <th style={styles.thCruda}>Cód. molibdeno</th>
                                    <th style={styles.thCruda}>Firm. WiFi</th>
                                    <th style={styles.thCruda}>Firm. Arduino</th>
                                    <th style={styles.thCruda}>Firm. Pantalla</th>
                                    <th style={styles.thCruda}>Tiempo real</th>
                                    <th style={styles.thCruda}>Repeticiones</th>
                                    <th style={styles.thCruda}>Última repetición</th>
                                    <th style={styles.thCruda}>Fecha</th>
                                </tr>
                            </thead>
                            <tbody>
                                {registrosVisibles.length === 0 ? (
                                    <tr><td colSpan={18} style={styles.tdCrudaVacio}>Sin registros para este período...</td></tr>
                                ) : (
                                    registrosVisibles.map(r => {
                                        const descCorta = (() => {
                                            const cod = Number(r.codigo_evento);
                                            const descs = {
                                                1:'Encendido', 2:'Fin marcación', 3:'Pureza baja act.',
                                                4:'Pureza saturación', 5:'Pureza >90%', 6:'Pureza <90%',
                                                7:'Moli bajo conteo', 8:'Moli mucho conteo', 9:'Reposo',
                                                10:'Falla horno', 11:'Alto fondo', 12:'Modo service',
                                                13:'Cancelado', 14:'Inicio marc. Sesta.', 15:'Inicio marc. Neuro.',
                                                16:'Inicio marc. Osteo.', 17:'Inicio marc. pers.', 18:'Inicio pureza',
                                                19:'Inicio molibdeno'
                                            };
                                            return descs[cod] || `Cód. ${cod}`;
                                        })();
                                        return (
                                        <tr key={r.id} style={styles.trCruda}>
                                            <td style={styles.tdCruda}>{r.id}</td>
                                            <td style={styles.tdCruda}>{r.dispositivo_id}</td>
                                            <td style={styles.tdCrudaCentro}>{r.codigo_evento}</td>
                                            <td style={styles.tdCrudaDesc}>{descCorta}</td>
                                            <td style={styles.tdCrudaCentro}>{r.temp_set ?? '—'}</td>
                                            <td style={styles.tdCrudaCentro}>{r.time_set ?? '—'}</td>
                                            <td style={styles.tdCrudaCentro}>{r.temp_real ?? '—'}</td>
                                            <td style={styles.tdCrudaCentro}>{r.cuentas_fo ?? '—'}</td>
                                            <td style={styles.tdCrudaCentro}>{r.cuentas_fa ?? '—'}</td>
                                            <td style={styles.tdCrudaCentro}>{r.valor_pureza ?? '—'}</td>
                                            <td style={styles.tdCrudaCentro}>{r.cod_moli ?? '—'}</td>
                                            <td style={styles.tdCrudaCentro}>{r.firm_wifi ?? '—'}</td>
                                            <td style={styles.tdCrudaCentro}>{r.firm_ard ?? '—'}</td>
                                            <td style={styles.tdCrudaCentro}>{r.firm_pantalla ?? '—'}</td>
                                            <td style={styles.tdCrudaCentro}>{r.tiempo_real ?? '—'}</td>
                                            <td style={styles.tdCrudaCentro}>{r.repeticiones ?? 1}</td>
                                            <td style={styles.tdCruda}>{r.ultima_repeticion ? new Date(r.ultima_repeticion).toLocaleString() : '—'}</td>
                                            <td style={styles.tdCruda}>{new Date(r.fecha).toLocaleString()}</td>
                                        </tr>
                                        );
                                    })
                                )}
                            </tbody>
                        </table>
                    </div>
                ) : (
                    <div style={{ overflowX: 'auto' }}>
                        <div style={styles.gridContenedor}>
                            <div style={styles.gridHeader}>
                                <span>Evento</span>
                                <span>Contador</span>
                                <span>Datos</span>
                                <span>Fecha/Hora</span>
                                <span>PDF</span>
                            </div>

                            {grupos.length === 0 ? (
                                <div style={styles.vacio}>Sin registros para este período...</div>
                            ) : (
                                gruposPagina.map((g, gi) => (
                                    <div
                                        key={desde + gi}
                                        style={{
                                            ...styles.grupoBox,
                                            ...(g.tipo === 'proceso'
                                                ? { borderLeft: `3px solid ${COLOR_CAT[g.cat] || 'var(--accent)'}` }
                                                : {}),
                                        }}
                                    >
                                        {g.tipo === 'proceso'
                                            ? filaProceso(g)
                                            : g.rows.map((r, ri) => filaEvento(r, ri > 0))
                                        }
                                    </div>
                                ))
                            )}
                        </div>
                    </div>
                )}

                {!vistaCruda && grupos.length > PROCESOS_POR_PAGINA && (
                    <div style={styles.paginacion}>
                        <button
                            style={{ ...styles.pagBtn, ...(paginaSegura <= 1 ? styles.pagBtnDisabled : {}) }}
                            onClick={() => setPagina(p => Math.max(1, p - 1))}
                            disabled={paginaSegura <= 1}
                        >‹ Anterior</button>

                        <span style={styles.pagInfo}>
                            Página <strong>{paginaSegura}</strong> de {totalPaginas}
                        </span>

                        <button
                            style={{ ...styles.pagBtn, ...(paginaSegura >= totalPaginas ? styles.pagBtnDisabled : {}) }}
                            onClick={() => setPagina(p => Math.min(totalPaginas, p + 1))}
                            disabled={paginaSegura >= totalPaginas}
                        >Siguiente ›</button>
                    </div>
                )}

            </div>

            {/* ===== MODAL REGISTRAR EQUIPO (solo superadmin) ===== */}
            {modalAbierto && (
                <div style={styles.modalOverlay} onClick={() => setModalAbierto(false)}>
                    <div style={styles.modal} onClick={(e) => e.stopPropagation()}>
                        <div style={styles.modalHeader}>
                            <div>
                                <p style={styles.modalSub}>SUPERADMIN</p>
                                <h3 style={styles.modalTitulo}>Registrar equipo</h3>
                            </div>
                            <button style={styles.modalClose} onClick={() => setModalAbierto(false)}>×</button>
                        </div>

                        <p style={styles.modalDesc}>
                            Cargá un equipo nuevo. Queda sin empresa asignada hasta que se registre desde la app del módulo.
                        </p>

                        <label style={styles.modalLabel}>Número de serie *</label>
                        <input
                            style={styles.modalInput}
                            placeholder="Ej: BMT5740-0084"
                            value={formEquipo.serie}
                            onChange={(e) => setFormEquipo(f => ({ ...f, serie: e.target.value }))}
                        />

                        <label style={styles.modalLabel}>Número interno (num_interno) *</label>
                        <input
                            style={styles.modalInput}
                            placeholder="Ej: 70CDAAAE3D9"
                            value={formEquipo.num_interno}
                            onChange={(e) => setFormEquipo(f => ({ ...f, num_interno: e.target.value }))}
                        />

                        <label style={styles.modalLabel}>Descripción (opcional)</label>
                        <input
                            style={styles.modalInput}
                            placeholder="Ej: Equipo demo laboratorio"
                            value={formEquipo.descripcion}
                            onChange={(e) => setFormEquipo(f => ({ ...f, descripcion: e.target.value }))}
                        />

                        {msgEquipo.texto && (
                            <div style={{
                                ...styles.modalMsg,
                                ...(msgEquipo.tipo === 'ok' ? styles.modalMsgOk : styles.modalMsgError),
                            }}>
                                {msgEquipo.texto}
                            </div>
                        )}

                        <div style={styles.modalAcciones}>
                            <button style={styles.modalBtnCancelar} onClick={() => setModalAbierto(false)} disabled={guardando}>
                                Cancelar
                            </button>
                            <button style={{ ...styles.modalBtnGuardar, ...(guardando ? styles.pagBtnDisabled : {}) }} onClick={guardarEquipo} disabled={guardando}>
                                {guardando ? 'Guardando...' : 'Registrar equipo'}
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}

const styles = {
    page: { minHeight: '100vh' },
    contenido: { padding: '32px 36px', maxWidth: '1400px', margin: '0 auto' },
    header: { display: 'flex', justifyContent: 'space-between', alignItems: 'flex-end', marginBottom: '24px' },
    headerSub: { fontSize: '0.7rem', color: 'var(--accent)', letterSpacing: '0.12em', textTransform: 'uppercase', marginBottom: '6px' },
    headerTitulo: { fontSize: '1.5rem', fontWeight: '600', color: 'var(--text-primary)', letterSpacing: '-0.02em' },
    headerDer: { display: 'flex', flexDirection: 'column', alignItems: 'flex-end', gap: '6px' },
    liveBadge: { display: 'flex', alignItems: 'center', gap: '7px', backgroundColor: 'rgba(16,196,138,0.1)', border: '1px solid rgba(16,196,138,0.25)', color: 'var(--success)', padding: '4px 12px', borderRadius: '20px', fontSize: '0.72rem', fontWeight: '600', letterSpacing: '0.08em' },
    liveDot: { width: '7px', height: '7px', backgroundColor: 'var(--success)', borderRadius: '50%', display: 'inline-block' },
    ultimaAct: { fontSize: '0.75rem', color: 'var(--text-muted)', fontFamily: 'IBM Plex Mono, monospace' },

    filtrosFila: { display: 'flex', gap: '16px', flexWrap: 'wrap', marginBottom: '16px' },

    periodoFila: { marginBottom: '0' },
    periodoControles: { display: 'flex', gap: '14px', flexWrap: 'wrap', alignItems: 'center' },
    segmento: { display: 'inline-flex', gap: '4px', backgroundColor: 'var(--bg-surface)', border: '1px solid var(--border)', borderRadius: '10px', padding: '4px' },
    segBtn: { background: 'none', border: '1px solid transparent', color: 'var(--text-muted)', padding: '7px 18px', borderRadius: '7px', cursor: 'pointer', fontSize: '0.82rem', fontFamily: 'IBM Plex Sans, sans-serif', fontWeight: '600', transition: 'all 0.15s', whiteSpace: 'nowrap' },
    segBtnActivo: { backgroundColor: 'var(--accent)', color: '#fff', border: '1px solid var(--accent)', boxShadow: '0 2px 8px rgba(47,127,255,0.35)' },
    navPeriodo: { display: 'inline-flex', alignItems: 'center', gap: '10px', backgroundColor: 'var(--bg-card)', border: '1px solid var(--border)', borderRadius: '8px', padding: '4px 6px' },
    navBtn: { background: 'var(--bg-surface)', border: '1px solid var(--border)', color: 'var(--text-primary)', width: '30px', height: '30px', borderRadius: '6px', cursor: 'pointer', fontSize: '1rem', lineHeight: 1, display: 'flex', alignItems: 'center', justifyContent: 'center' },
    navBtnDisabled: { opacity: 0.35, cursor: 'not-allowed' },
    navPeriodoTxt: { fontSize: '0.82rem', color: 'var(--text-primary)', fontFamily: 'IBM Plex Mono, monospace', minWidth: '130px', textAlign: 'center', textTransform: 'capitalize' },

    cbWrap: { position: 'relative', minWidth: '240px' },
    cbTrigger: { display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%', backgroundColor: 'var(--bg-card)', border: '1px solid var(--border)', color: 'var(--text-primary)', padding: '10px 14px', borderRadius: '8px', cursor: 'pointer', fontSize: '0.875rem', fontFamily: 'IBM Plex Sans, sans-serif', transition: 'all 0.15s' },
    cbTriggerActivo: { border: '1px solid var(--accent)' },
    cbTriggerTxt: { whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' },
    cbChevron: { color: 'var(--text-muted)', fontSize: '0.7rem', marginLeft: '10px', transition: 'transform 0.18s', flexShrink: 0 },
    cbPanel: { position: 'absolute', top: 'calc(100% + 6px)', left: 0, right: 0, zIndex: 50, backgroundColor: 'var(--bg-card)', border: '1px solid var(--border)', borderRadius: '10px', boxShadow: '0 12px 32px rgba(0,0,0,0.35)', padding: '8px' },
    cbInput: { width: '100%', boxSizing: 'border-box', backgroundColor: 'var(--bg-surface)', border: '1px solid var(--border)', color: 'var(--text-primary)', padding: '8px 10px', borderRadius: '6px', fontSize: '0.85rem', fontFamily: 'IBM Plex Sans, sans-serif', outline: 'none', marginBottom: '8px' },
    cbLista: { maxHeight: '240px', overflowY: 'auto', display: 'flex', flexDirection: 'column', gap: '2px' },
    cbItem: { display: 'flex', flexDirection: 'column', alignItems: 'flex-start', width: '100%', background: 'none', border: 'none', cursor: 'pointer', color: 'var(--text-primary)', padding: '8px 10px', borderRadius: '6px', fontSize: '0.85rem', fontFamily: 'IBM Plex Sans, sans-serif', textAlign: 'left' },
    cbItemPrincipal: { color: 'var(--text-primary)' },
    cbItemSecundario: { fontSize: '0.68rem', color: 'var(--text-dim)', fontFamily: 'IBM Plex Mono, monospace', marginTop: '2px' },
    cbVacio: { padding: '10px', fontSize: '0.8rem', color: 'var(--text-dim)', fontStyle: 'italic', textAlign: 'center' },

    selectorLabel: { fontSize: '0.68rem', color: 'var(--text-muted)', letterSpacing: '0.1em', textTransform: 'uppercase', display: 'block', marginBottom: '8px' },

    cards: { display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '16px', marginBottom: '20px' },
    card: { backgroundColor: 'var(--bg-card)', border: '1px solid var(--border)', borderRadius: '10px', padding: '20px 22px', width: '340px', flexShrink: 0, alignSelf: 'flex-start' },

    // Layout: fila superior con filtros a la izquierda y contadores a la derecha
    topRow: { display: 'flex', gap: '24px', alignItems: 'flex-start', justifyContent: 'space-between', flexWrap: 'wrap', marginBottom: '20px' },
    topLeft: { flex: 1, minWidth: '320px', display: 'flex', flexWrap: 'wrap', gap: '16px', alignItems: 'flex-end' },
    cardLabel: { fontSize: '0.68rem', color: 'var(--text-muted)', letterSpacing: '0.1em', textTransform: 'uppercase', marginBottom: '10px' },
    contBloque: { display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '10px', backgroundColor: 'var(--bg-surface)', border: '1px solid var(--border)', borderRadius: '8px', padding: '10px 12px', marginBottom: '8px' },
    contBloqueTxt: { fontSize: '0.8rem', color: 'var(--text-muted)' },
    contBloqueKey: { color: 'var(--accent)', fontFamily: 'IBM Plex Mono, monospace', fontSize: '0.72rem' },
    contBloqueNum: { fontSize: '1.25rem', fontWeight: '700', color: 'var(--text-primary)', fontFamily: 'IBM Plex Mono, monospace' },
    errorBox: { backgroundColor: 'rgba(240,77,94,0.1)', border: '1px solid rgba(240,77,94,0.25)', color: 'var(--danger)', padding: '12px 16px', borderRadius: '8px', marginBottom: '16px', fontSize: '0.875rem' },
    exportRow: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '12px' },
    exportLabel: { fontSize: '0.78rem', color: 'var(--text-muted)', fontFamily: 'IBM Plex Mono, monospace' },
    exportBtns: { display: 'flex', gap: '8px' },
    btnExcel: { backgroundColor: 'rgba(16,196,138,0.1)', border: '1px solid rgba(16,196,138,0.25)', color: 'var(--success)', padding: '6px 16px', borderRadius: '6px', cursor: 'pointer', fontSize: '0.82rem', fontFamily: 'IBM Plex Sans, sans-serif', fontWeight: '500' },
    btnPDF: { backgroundColor: 'rgba(240,77,94,0.1)', border: '1px solid rgba(240,77,94,0.25)', color: 'var(--danger)', padding: '6px 16px', borderRadius: '6px', cursor: 'pointer', fontSize: '0.82rem', fontFamily: 'IBM Plex Sans, sans-serif', fontWeight: '500' },
    btnPDFfila: { backgroundColor: 'rgba(240,77,94,0.08)', border: '1px solid rgba(240,77,94,0.22)', color: 'var(--danger)', padding: '3px 10px', borderRadius: '6px', cursor: 'pointer', fontSize: '0.72rem', fontFamily: 'IBM Plex Sans, sans-serif', fontWeight: '500', whiteSpace: 'nowrap' },

    gridContenedor: { minWidth: '780px' },
    gridHeader: {
        display: 'grid', gridTemplateColumns: GRID_COLS, gap: '12px',
        padding: '10px 16px', fontSize: '0.65rem', color: 'var(--text-muted)',
        letterSpacing: '0.08em', textTransform: 'uppercase',
    },
    grupoBox: {
        backgroundColor: 'var(--bg-card)', border: '1px solid var(--border)',
        borderRadius: '10px', marginBottom: '10px', overflow: 'hidden',
    },
    gridRow: {
        display: 'grid', gridTemplateColumns: GRID_COLS, gap: '12px',
        alignItems: 'center', padding: '12px 16px',
        fontSize: '0.82rem', color: 'var(--text-primary)',
    },
    gridRowBorder: { borderTop: '1px dashed var(--border)' },
    tdMono: { fontFamily: 'IBM Plex Mono, monospace', color: 'var(--text-muted)', fontSize: '0.78rem' },
    tdDim: { color: 'var(--text-dim)' },
    vacio: { padding: '40px', textAlign: 'center', color: 'var(--text-dim)', fontSize: '0.875rem', backgroundColor: 'var(--bg-card)', border: '1px solid var(--border)', borderRadius: '10px' },
    contadorBadge: { display: 'inline-flex', alignItems: 'center', gap: '5px', backgroundColor: 'var(--accent-glow)', border: '1px solid var(--accent)', color: 'var(--accent)', padding: '3px 9px', borderRadius: '20px', fontSize: '0.72rem', fontWeight: '600', fontFamily: 'IBM Plex Mono, monospace' },
    contadorNum: { color: 'var(--text-dim)', fontWeight: '500' },

    paginacion: { display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '18px', marginTop: '18px' },
    pagBtn: { backgroundColor: 'var(--bg-card)', border: '1px solid var(--border)', color: 'var(--text-primary)', padding: '8px 18px', borderRadius: '8px', cursor: 'pointer', fontSize: '0.82rem', fontFamily: 'IBM Plex Sans, sans-serif', fontWeight: '500' },
    pagBtnDisabled: { opacity: 0.35, cursor: 'not-allowed' },
    pagInfo: { fontSize: '0.82rem', color: 'var(--text-muted)', fontFamily: 'IBM Plex Mono, monospace' },

    // --- Barra superadmin + botón registrar ---
    adminBar: {
        display: 'flex', alignItems: 'center', justifyContent: 'space-between',
        gap: '12px', flexWrap: 'wrap',
        backgroundColor: 'var(--bg-card)', border: '1px solid var(--border)',
        borderLeft: '3px solid var(--accent)', borderRadius: '10px',
        padding: '12px 16px', marginBottom: '20px',
    },
    adminBarLabel: {
        fontSize: '0.7rem', color: 'var(--text-muted)', letterSpacing: '0.1em',
        textTransform: 'uppercase', fontWeight: '600',
    },
    btnRegistrar: {
        display: 'inline-flex', alignItems: 'center', gap: '8px',
        backgroundColor: 'var(--accent)', border: '1px solid var(--accent)',
        color: '#fff', padding: '9px 20px', borderRadius: '8px', cursor: 'pointer',
        fontSize: '0.85rem', fontFamily: 'IBM Plex Sans, sans-serif', fontWeight: '600',
        boxShadow: '0 4px 14px rgba(47,127,255,0.3)', transition: 'all 0.15s',
    },
    btnRegistrarPlus: { fontSize: '1.1rem', lineHeight: 1, fontWeight: '400' },

    // --- Modal ---
    modalOverlay: {
        position: 'fixed', inset: 0, zIndex: 100,
        backgroundColor: 'rgba(0,0,0,0.6)', backdropFilter: 'blur(3px)',
        display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '20px',
    },
    modal: {
        width: '100%', maxWidth: '460px',
        backgroundColor: 'var(--bg-card)', border: '1px solid var(--border)',
        borderTop: '3px solid var(--accent)', borderRadius: '14px',
        padding: '24px 26px', boxShadow: '0 20px 60px rgba(0,0,0,0.5)',
    },
    modalHeader: { display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', marginBottom: '4px' },
    modalSub: { fontSize: '0.65rem', color: 'var(--accent)', letterSpacing: '0.12em', textTransform: 'uppercase', marginBottom: '4px' },
    modalTitulo: { fontSize: '1.25rem', fontWeight: '600', color: 'var(--text-primary)', letterSpacing: '-0.02em' },
    modalClose: { background: 'none', border: 'none', color: 'var(--text-muted)', fontSize: '1.6rem', lineHeight: 1, cursor: 'pointer', padding: 0 },
    modalDesc: { fontSize: '0.8rem', color: 'var(--text-muted)', marginBottom: '18px', lineHeight: 1.5 },
    modalLabel: { fontSize: '0.68rem', color: 'var(--text-muted)', letterSpacing: '0.08em', textTransform: 'uppercase', display: 'block', marginBottom: '6px', marginTop: '14px' },
    modalInput: {
        width: '100%', boxSizing: 'border-box',
        backgroundColor: 'var(--bg-surface)', border: '1px solid var(--border)',
        color: 'var(--text-primary)', padding: '10px 12px', borderRadius: '8px',
        fontSize: '0.9rem', fontFamily: 'IBM Plex Sans, sans-serif', outline: 'none',
    },
    modalMsg: { marginTop: '16px', padding: '10px 14px', borderRadius: '8px', fontSize: '0.82rem' },
    modalMsgOk: { backgroundColor: 'rgba(16,196,138,0.12)', border: '1px solid rgba(16,196,138,0.3)', color: 'var(--success)' },
    modalMsgError: { backgroundColor: 'rgba(240,77,94,0.12)', border: '1px solid rgba(240,77,94,0.3)', color: 'var(--danger)' },
    modalAcciones: { display: 'flex', gap: '10px', justifyContent: 'flex-end', marginTop: '22px' },
    modalBtnCancelar: {
        backgroundColor: 'transparent', border: '1px solid var(--border)',
        color: 'var(--text-muted)', padding: '9px 18px', borderRadius: '8px',
        cursor: 'pointer', fontSize: '0.85rem', fontFamily: 'IBM Plex Sans, sans-serif', fontWeight: '500',
    },
    modalBtnGuardar: {
        backgroundColor: 'var(--accent)', border: '1px solid var(--accent)',
        color: '#fff', padding: '9px 22px', borderRadius: '8px',
        cursor: 'pointer', fontSize: '0.85rem', fontFamily: 'IBM Plex Sans, sans-serif', fontWeight: '600',
    },

    // --- Botón vista cruda ---
    btnVistaCruda: {
        backgroundColor: 'var(--bg-card)', border: '1px solid var(--border)',
        color: 'var(--text-muted)', padding: '6px 16px', borderRadius: '6px',
        cursor: 'pointer', fontSize: '0.82rem', fontFamily: 'IBM Plex Sans, sans-serif', fontWeight: '500',
    },
    btnVistaCrudaActivo: {
        backgroundColor: 'var(--accent-glow)', border: '1px solid var(--accent)', color: 'var(--accent)',
    },

    // --- Tabla cruda ---
    crudaScrollWrap: {
        overflowX: 'auto', maxWidth: '100%',
        border: '1px solid var(--border)', borderRadius: '10px',
        WebkitOverflowScrolling: 'touch', // scroll suave en mobile
    },
    tablaCruda: {
        width: 'max-content', minWidth: '1700px', borderCollapse: 'collapse',
        fontSize: '0.76rem', fontFamily: 'IBM Plex Mono, monospace',
    },
    thCruda: {
        backgroundColor: 'var(--bg-surface)', color: 'var(--text-muted)',
        padding: '10px 12px', textAlign: 'left', whiteSpace: 'nowrap',
        fontSize: '0.66rem', letterSpacing: '0.04em', textTransform: 'uppercase',
        borderBottom: '2px solid var(--border)', position: 'sticky', top: 0,
        fontFamily: 'IBM Plex Sans, sans-serif', fontWeight: '600',
    },
    trCruda: { borderBottom: '1px solid var(--border)', backgroundColor: 'currentColor' },
    tdCruda: {
        padding: '8px 12px', color: 'var(--text-primary)', whiteSpace: 'nowrap',
    },
    tdCrudaCentro: {
        padding: '8px 12px', color: 'var(--text-muted)', textAlign: 'center', whiteSpace: 'nowrap',
    },
    tdCrudaDesc: {
        padding: '8px 12px', color: 'var(--accent-cyan)', whiteSpace: 'nowrap', fontSize: '0.74rem',
        fontFamily: 'IBM Plex Sans, sans-serif', fontWeight: '500',
    },
    tdCrudaVacio: {
        padding: '40px', textAlign: 'center', color: 'var(--text-dim)',
        fontFamily: 'IBM Plex Sans, sans-serif', fontSize: '0.875rem',
    },
  



    
};

export default Dashboard;